
import InviteForm from '@/components/Management/User/InviteForm';

export default {
  components: {
    InviteForm
  }
};
